import { Variants } from 'common';
import { PaletteMode } from '@mui/material';
import { createTheme, PaletteOptions } from '@mui/material/styles';

import breakpoints from './breakpoints';
import typography from './typography';
import spacing from './spacing';
// FiveIron
import fiveIronComponents from './fiveiron/components';
import fiveIronPalette from './fiveiron/palette';
// DuckPin
import duckpinComponents from './duckpin/components';
import duckpinPalette from './duckpin/palette';

const resolveComponents = (variant?: Variants) => {
  switch (variant) {
    case Variants.DUCKPIN:
      return duckpinComponents;
    case Variants.FIVEIRON:
      return fiveIronComponents;
    default:
      return fiveIronComponents;
  }
};

const resolvePalette = (variant?: Variants) => {
  switch (variant) {
    case Variants.DUCKPIN:
      return duckpinPalette;
    case Variants.FIVEIRON:
      return fiveIronPalette;
    default:
      return fiveIronPalette;
  }
};

// `mode` and `paletteOverride` let createTheme re-augment derived tokens (divider,
// text.disabled, grey, elevation overlays) per color mode instead of spreading a raw
// palette onto a light-built theme.
const theme = (
  variant?: Variants,
  mode: PaletteMode = 'light',
  paletteOverride: Partial<PaletteOptions> = {},
) =>
  createTheme({
    breakpoints,
    components: resolveComponents(variant),
    palette: { ...resolvePalette(variant), mode, ...paletteOverride } as PaletteOptions,
    spacing,
    typography,
  });

export default theme;
